// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GaPublisher from "./publishers/GaPublisher.bs.js";

function getGaEventPayload(payload) {
  return {
          category: payload.category,
          action: payload.action,
          label: payload.label,
          value: payload.value,
          nonInteraction: payload.nonInteraction
        };
}

function publishEvent(payload) {
  return GaPublisher.publishGaEvent(getGaEventPayload(payload));
}

function getPageViewPayload(pageViewParams) {
  return {
          hitType: "pageview",
          page: pageViewParams.path,
          title: pageViewParams.title
        };
}

function publishPageview(pageViewParams) {
  return GaPublisher.publishGaPageview(getPageViewPayload(pageViewParams));
}

export {
  publishEvent ,
  publishPageview ,
  
}
/* GaPublisher Not a pure module */
